import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=5e60cfa3&scoped=true&"
import script from "./Msg.vue?vue&type=script&lang=ts&"
export * from "./Msg.vue?vue&type=script&lang=ts&"
import style0 from "./Msg.vue?vue&type=style&index=0&id=5e60cfa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e60cfa3",
  null
  
)

export default component.exports